import styled from "styled-components";
import { NavLink } from "react-router-dom";

export const Container = styled.div`
  width: 150px;
  background: ${props => props.theme.backgroundDark};
  padding-top: 12px;
  z-index: 100000;
  padding-bottom: 12px;
  border: ${props => props.theme.border.standard} solid
    ${props => props.theme.border.color};
  border-radius: ${props => props.theme.br.md};

  .active-menu-item {
    background-color: ${props => props.theme.primary};

    p {
      color: ${props => props.theme.textLight};
    }
  }

  .break-line {
    opacity: 0.2;
    width: 85%;
    margin: auto;
    margin-bottom: 10px;
    margin-top: -2px;
    background-color: ${props => props.theme.textLight};
    height: 1.5px;
  }
`;

export const MenuItem = styled(NavLink)`
  display: flex;
  align-items: center;
  margin: 0 8px 2px;
  padding: 6px 14px;
  border-radius: ${props => props.theme.br.md};
  transition: background-color 0.15s ease;

  ${props => props.$isSubscription && "margin-left: 16px;"}

  &:hover {
    background-color: ${props => props.theme.backgroundHover};
  }

  &:active {
    background-color: ${props => props.theme.primary};
  }

  p {
    font-size: ${props => props.theme.p3b.fs};
    font-family: ${props => props.theme.p3b.ff};
    color: ${props => props.theme.textLight};
    text-align: left;
  }
`;

export const SignupItem = styled(MenuItem)`
  && {
    justify-content: center;
    height: 24px;
    padding: 6px 12px;
    margin: 6px 12px 2px;
    background-color: ${props => props.theme.palette[4]};
    border-radius: ${props => props.theme.br.lg};
  }

  &&:hover {
    background-color: ${props => props.theme.palette[4]};
  }

  p {
    text-align: center;
  }
`;
